import React from "react";
import {Dropdown, DropdownChangeParams} from "primereact/dropdown";
import { T } from "services/lang/LanguageService";
import useAccessibleCompanies from "../../../hooks/useAccessibleCompanies";
import {useUserState} from "../../../store/user-store";
import useCurrentCompanyContext from "../../../hooks/useCurrentCompanyContext";
import {useHasPermissions} from "../../../hooks/useHasPermissions";

export default function CompanyContextSelectFragment() {
    const isAdmin = useHasPermissions("ADMIN")
    if(!isAdmin) return false

    const companies = useAccessibleCompanies()
    if(!companies) return false

    if(companies.length <= 1) {
        return false
    }

    const currentContext = useCurrentCompanyContext()
    const setCurrentContext = useUserState((state) => state.setCompanyContext)

    const selectItems =  companies?.map((company) => {
        return {
            label: company.title,
            value: company.companyReference
        }
    })

    const onChangeHandler = (e: DropdownChangeParams) => {
        const company = companies?.find((company) => company.companyReference === e.value)
        setCurrentContext(company)
    }

    return <Dropdown placeholder={T("action.select-company-context")}
                  value={currentContext?.companyReference}
                  options={selectItems}
                  filter
                  filterMatchMode="contains"
                  onChange={onChangeHandler}
        />
}